import type { VehicleOffers } from '../../Entities/Vehicle/VehicleOffers.entity';

export const HEYCAR_DAYS_DISCOUNT = 'heycar_days';

// Check the history of this file to bring back multiple campaign as per requirement
export const getPromotionFlags = (
  offers: VehicleOffers = { offers: [], promotions: [] },
  flags: Record<string, boolean>,
) => {
  const isHeycarDaysCampaign =
    flags.heycarDaysPromotion &&
    offers?.offers.some(offer => offer.toUpperCase().includes(HEYCAR_DAYS_DISCOUNT.toUpperCase()));
  // Add more flags to the promotionFlags object as needed
  const promotionFlags = {
    isHeycarDaysCampaign,
  };

  return promotionFlags;
};

export const isAnyPromotionActive = (promotionFlags?: Record<string, boolean>) =>
  promotionFlags && Object.values(promotionFlags).some(flag => flag === true);
